import { useBreadcrumb } from "components/breadcrumb/BreadcrumbContext";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import SEOMeta from "components/SEOMeta";
import { brandConfig } from "config/brandConfig";

export default function MentionsLegales() {
  const lastUpdated = new Date().toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }); // mets à jour si besoin

  const { setItems } = useBreadcrumb();
  useEffect(() => {
    setItems([{ label: "Accueil", href: "/" }, { label: "Mentions légales" }]);
  }, [setItems]);
  return (
    <>
      <SEOMeta
        title="Mentions légales"
        description={`Mentions légales de ${brandConfig.brandName}, fabricant français d'armoires à fusils sécurisées.`}
        canonicalPath="/mentions-legales"
      />
      <main
        role="main"
        style={{ maxWidth: 960, margin: "0 auto", padding: "24px 16px" }}
      >
        <h1 style={{ marginTop: 12 }}>Mentions légales</h1>
        <p style={{ fontSize: 14, opacity: 0.8, marginTop: 4 }}>
          Dernière mise à jour : {lastUpdated}
        </p>

        <section id="editeur" style={{ marginTop: 24 }}>
          <h2>Informations sur l’éditeur du site</h2>
          <p>
            <strong>M4Sécurité</strong>
          </p>
          <address style={{ fontStyle: "normal" }}>
            11 Rue Raspail, 94230 Cachan, France
          </address>
          <ul>
            <li>
              E-mail :{" "}
              <Link to="mailto:contact@kaisersafe.com">
                contact@kaisersafe.com
              </Link>
            </li>
            <li>
              Téléphone : <a href="tel:+33978808686">+33 9 78 80 86 86</a>
            </li>
          </ul>
        </section>

        <section id="direction" style={{ marginTop: 24 }}>
          <h2>Direction de la publication</h2>
          <p>
            Responsable de la publication : <em>Clément Forestier / associé</em>
          </p>
        </section>

        <section id="hebergeur" style={{ marginTop: 24 }}>
          <h2>Hébergement du site</h2>
          <p>
            <em>OVH</em>
            <br />
            <em>2 RUE KELLERMANN 59100 ROUBAIX</em>
            <br />
          </p>
        </section>

        <section id="propriete-intellectuelle" style={{ marginTop: 24 }}>
          <h2>Propriété intellectuelle</h2>
          <p>
            L’ensemble des contenus présents sur ce site (textes, images, logos,
            vidéos, documents téléchargeables, etc.) est la propriété exclusive
            de <strong>M4Sécurité</strong>, sauf mention contraire. Toute
            reproduction, représentation, modification, distribution ou
            exploitation, totale ou partielle, est interdite sans autorisation
            écrite préalable.
          </p>
        </section>

        <section id="responsabilite" style={{ marginTop: 24 }}>
          <h2>Responsabilité</h2>
          <p>
            <strong>M4Sécurité</strong> met tout en œuvre pour assurer
            l’exactitude et la mise à jour des informations diffusées sur le
            site. Elle ne saurait toutefois être tenue responsable d’erreurs,
            d’omissions, d’indisponibilités temporaires ou de tout dommage
            résultant de l’utilisation du site.
          </p>
          <p>
            Les liens hypertextes vers des sites tiers sont fournis à titre
            informatif.
            <strong> M4Sécurité</strong> n’exerce aucun contrôle sur leur
            contenu et décline toute responsabilité à cet égard.
          </p>
        </section>

        <section id="donnees" style={{ marginTop: 24 }}>
          <h2>Protection des données</h2>
          <p>
            Les données personnelles collectées via ce site sont traitées
            conformément au Règlement (UE) 2016/679 relatif à la protection des
            données (RGPD) et à la loi française « Informatique et Libertés ».
            Pour plus d’informations (types de données, finalités, bases
            légales, durées de conservation, droits des personnes, etc.),
            veuillez consulter notre{" "}
            <Link to="/politique-de-confidentialite">
              Politique de confidentialité
            </Link>
            .
          </p>
        </section>

        <section id="cookies" style={{ marginTop: 24 }}>
          <h2>Cookies</h2>
          <p>
            Le site peut utiliser des cookies et technologies similaires à des
            fins de mesure d’audience et d’amélioration de l’expérience
            utilisateur. Vous pouvez gérer vos préférences dans le bandeau de
            consentement ou via les paramètres de votre navigateur. Pour en
            savoir plus, consultez notre
            <Link to="/politique-de-confidentialite#cookies">
              {" "}
              Politique de confidentialité (section Cookies)
            </Link>
            .
          </p>
        </section>

        <section id="droit-applicable" style={{ marginTop: 24 }}>
          <h2>Droit applicable et for</h2>
          <p>
            Les présentes mentions légales sont régies par le{" "}
            <strong>droit français</strong>. En cas de litige et à défaut de
            résolution amiable, les tribunaux français territorialement
            compétents seront seuls compétents.
          </p>
        </section>

        <section id="contact" style={{ marginTop: 24 }}>
          <h2>Contact</h2>
          <p>
            Pour toute question, vous pouvez contacter{" "}
            <strong>M4Sécurité</strong> :
            <br />
            E-mail :{" "}
            <a href="mailto:contact@kaisersafe.com">contact@kaisersafe.com</a> —
            Téléphone : <a href="tel:+33785756439">+33 78 575 64 39</a>
          </p>
        </section>
      </main>
    </>
  );
}
